export const rate = (value: number | null, unit: string | null) =>
  value == null
    ? "—"
    : `${new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 1 }).format(value)} ${unit ?? "birim"}/dk`;
